import { render, staticRenderFns } from "./TrademarkAudit.vue?vue&type=template&id=2244274a&scoped=true"
import script from "./TrademarkAudit.vue?vue&type=script&lang=js"
export * from "./TrademarkAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2244274a",
  null
  
)

export default component.exports